module.exports = __webpack_public_path__ + "media/components/country-flag/static/sm-73469c6cad2a9ef8555013083c831b91.svg";